import CustomButton from "@/src/lib/ui/Button";

const DeletePatientFromCartPopup = ({ removeTest, open, onClose }) => {
    return (
        <div className="flex flex-col justify-center items-center">
            <h4 className="text-primary text-2x font-bold uppercase">Alert</h4>
            <h4 className="text-black md:text-lg text-base md:font-bold font-medium text-center max-w-64 w-full mt-2">
                Are you sure you want to delete this Test?
            </h4>

            <div className="flex flex-row w-full mt-5 gap-3">
                <CustomButton
                    fullWidth
                    variant="contained"
                    onClick={() => removeTest(open)}
                >
                    Confirm
                </CustomButton>
                <CustomButton fullWidth variant="outlined" onClick={onClose}>
                    Cancel
                </CustomButton>
            </div>
        </div>
    );
};

export default DeletePatientFromCartPopup;
